<div class="ui-tabview ui-widget ui-widget-content ui-tabview-top mb-3 task-tab-bar">
  <ul
    class="ui-tabview-nav ui-helper-reset ui-helper-clearfix ui-widget-header"
    style="padding-left: 0"
  >
    <li
      *ngFor="let task of tasks; let i = index"
      (click)="clickedTask(task.id)"
      [class.ui-state-active]="task.id == selectedTaskId"
      [class.ui-state-default]="task.id != selectedTaskId"
    >
      <a> {{ task.regNumber }} </a>
    </li>
  </ul>
</div>

<div *ngFor="let task of tasks; let i = index">
  <ng-container
    [ngTemplateOutlet]="taskScreen"
    [ngTemplateOutletContext]="{ task, visible: task.id == selectedTaskId, selectedTask }"
  ></ng-container>
</div>

<ng-template #taskScreen let-containerTask="task" let-visible="visible" let-ç="selectedTask">
  <div style="padding: 0 20px" [hidden]="!visible" *ngIf="selectedTask">
    <div
      style="display: flex; flex-wrap: wrap; grid-gap: 15px; margin-top: 15px"
      class="sm:flex-wrap md:flex-nowrap"
    >
      <div style="flex-basis: 310px; flex-grow: 1; min-width: 310px">
        <vme-job-screen-tasks-service-type
          [organisationTypeId]="organisationTypeId"
          [organisationId]="organisationId"
          [jobId]="jobId"
          [orderId]="orderId"
          [serviceTypeTask]="selectedTask.serviceType"
        ></vme-job-screen-tasks-service-type>

        <vme-job-screen-recognition
          [organisationTypeId]="organisationTypeId"
          [organisationId]="organisationId"
          [recognitionTask]="selectedTask.recognition"
          [jobId]="jobId"
          [orderId]="orderId"
        ></vme-job-screen-recognition>

        <job-screen-model-pin
          [organisationTypeId]="organisationTypeId"
          [organisationId]="organisationId"
          [modelPinTask]="selectedTask.modelPin"
          [jobId]="jobId"
          [orderId]="orderId"
        ></job-screen-model-pin>

        <job-screen-release-code
          [organisationTypeId]="organisationTypeId"
          [organisationId]="organisationId"
          [releaseCodeTask]="selectedTask.releaseCode"
          [jobId]="jobId"
          [orderId]="orderId"
        ></job-screen-release-code>

        <job-screen-driver-details
          [organisationTypeId]="organisationTypeId"
          [organisationId]="organisationId"
          [driverDetailsTask]="selectedTask.driverDetails"
          [jobId]="jobId"
          [orderId]="orderId"
        ></job-screen-driver-details>

        <job-screen-driver-notes
          [organisationTypeId]="organisationTypeId"
          [organisationId]="organisationId"
          [taskId]="containerTask.id"
          [jobId]="jobId"
          [orderId]="orderId"
        ></job-screen-driver-notes>

        <job-screen-site-opening
          [organisationTypeId]="organisationTypeId"
          [taskId]="containerTask.id"
        ></job-screen-site-opening>

        <job-screen-contact-people
          [organisationTypeId]="organisationTypeId"
          [contactPeopleTask]="selectedTask.contactPeople"
        ></job-screen-contact-people>

        <job-screen-inspection-contacts
          [organisationTypeId]="organisationTypeId"
          [taskId]="containerTask.id"
        ></job-screen-inspection-contacts>

        <job-screen-inspection-handover
          [organisationTypeId]="organisationTypeId"
          [taskId]="containerTask.id"
        ></job-screen-inspection-handover>

        <job-screen-fuel-levels
          [organisationTypeId]="organisationTypeId"
          [fuelLevelTask]="selectedTask.fuelLevels"
        ></job-screen-fuel-levels>

        <job-screen-vehicle-cleanliness
          [organisationTypeId]="organisationTypeId"
          [vehicleCleanlinessTask]="selectedTask.vehicleCleanliness"
        ></job-screen-vehicle-cleanliness>

        <job-screen-odometer-readings
          [organisationTypeId]="organisationTypeId"
          [odometerTask]="selectedTask.odometerReadings"
        ></job-screen-odometer-readings>

        <job-screen-late-status
          [organisationTypeId]="organisationTypeId"
          [lateStatusTask]="selectedTask.lateStatus"
        ></job-screen-late-status>
      </div>
      <div style="flex-grow: 100">
        <job-screen-checklist [organisationTypeId]="organisationTypeId" [taskId]="containerTask.id">
        </job-screen-checklist>

        <job-screen-vehicle-information
          [organisationTypeId]="organisationTypeId"
          [taskId]="containerTask.id"
        ></job-screen-vehicle-information>

        <div class="mt-3">
          <job-screen-image-gallery
            [organisationTypeId]="organisationTypeId"
            [taskId]="containerTask.id"
            [jobId]="jobId"
          ></job-screen-image-gallery>
        </div>

        <div class="mt-3" *ngIf="job?.supplierId != null">
          <job-screen-driver-messages
            [organisationTypeId]="organisationTypeId"
            [taskId]="containerTask.id"
            [jobId]="jobId"
          ></job-screen-driver-messages>
        </div>

        <div class="mt-3" *ngIf="job?.supplierId != null">
          <job-screen-driver-performance
            [organisationTypeId]="organisationTypeId"
            [taskId]="containerTask.id"
          ></job-screen-driver-performance>
        </div>
      </div>
    </div>
  </div>
</ng-template>
